"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var constants_1 = require("../constants");
var types_1 = require("../types");
var Cart_1 = require("./Cart");
var RubicsRequest_1 = require("./RubicsRequest");
var PRODUCTS_ENDPOINT = constants_1.STOREFRONT_ENDPOINT + "/products";
var Product = /** @class */ (function () {
    function Product() {
    }
    Product.default = function () {
        return defaultProduct;
    };
    Product.getPrimaryImage = function (product) {
        if (!Array.isArray(product.images) || product.images.length < 1) {
            return constants_1.PLACEHOLDER_IMAGE;
        }
        var primary = product.images.find(function (i) { return !!i.primary; });
        if (primary) {
            if (!!primary.ref) {
                return primary;
            }
            return constants_1.PLACEHOLDER_IMAGE;
        }
        var image = product.images[0];
        if (!!image.ref) {
            return image;
        }
        return constants_1.PLACEHOLDER_IMAGE;
    };
    Product.getSimpleVariantFromFilter = function (opts) {
        return __awaiter(this, void 0, void 0, function () {
            var endpoint, product, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        endpoint = PRODUCTS_ENDPOINT + "/" + opts.productID + "/simple-variants/from-attributes";
                        return [4 /*yield*/, RubicsRequest_1.default.fetch({
                                endpoint: endpoint,
                                queryParams: opts.filter,
                            })];
                    case 1:
                        product = _a.sent();
                        return [2 /*return*/, product];
                    case 2:
                        error_1 = _a.sent();
                        return [2 /*return*/, null];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    Product.getPurchaseLimits = function (product, cart) {
        if (product.stockStatus === types_1.StockStatus.OutOfStock) {
            return {
                max: 0,
            };
        }
        var limits = {};
        if (product.hasLimitation) {
            limits.min = product.limitationMin;
            limits.max = product.limitationMax;
            if (cart) {
                var amountInCart = Cart_1.default.getAmountOfProductInCart(cart, product._id);
                if (typeof limits.min === "number") {
                    limits.min = limits.min - amountInCart;
                    limits.minLimitReason = product.limitationType;
                }
                if (typeof limits.max === "number") {
                    limits.max = limits.max - amountInCart;
                    limits.maxLimitReason = product.limitationType;
                }
            }
        }
        if (typeof product.stockCount === "number") {
            if (typeof limits.max !== "number" || limits.max > product.stockCount) {
                limits.max = product.stockCount;
                limits.maxLimitReason = "stock";
            }
        }
        return limits;
    };
    return Product;
}());
var defaultProduct = {
    _id: "mitt-produkt",
    name: "Mitt produkt",
    slug: "mitt-produkt",
    url: constants_1.PRODUCT_PATH + "/mitt-produkt",
    sku: "mitt-produkt",
    price: {
        value: 150,
        compareAtValue: 200,
    },
    images: [
        {
            ref: "img",
            alt: "Mitt produkt",
            url: "https://res.cloudinary.com/oyvindhermansen/image/upload/v1561016972/empty_preview.png",
            focus: {},
        },
    ],
    variants: [],
    attributes: [],
    customizeOptions: [],
    categories: [],
    variantDistribution: [],
};
exports.default = Product;
//# sourceMappingURL=Product.js.map